import { Popover } from "antd";
import React, { useRef } from "react";
import { Header } from "./Header";
import { InnerStyle } from "../style";
import { onVisibleChange } from "../../../../../helpers/flow";

export const Node = ({
  el,
  renderPopOver,
  setPopoverVisible = () => { },
}) => {
  const ref = useRef();
  const _open = () => ref.current.click();

  const _onVisibleChange = (value) => {
    setPopoverVisible(value);
    onVisibleChange(value);
  };

  return (
    <Popover
      content={renderPopOver(el.config, _open)}
      onOpenChange={_onVisibleChange}
      trigger="click"
      placement="right"
    >
      <div ref={ref}>
        <InnerStyle>
          <Header
            config={el.config}
            isActive={true}
          />
        </InnerStyle>
      </div>
    </Popover>

  );
}

